module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "documento"
  }, [_vm._m(0), _c('div', {
    staticClass: "texto"
  }, [_c('p', {
    staticClass: "titulo"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": _vm.arquivo.url
    }
  }, [_vm._v(_vm._s(_vm.arquivo.nome))])])]), _c('p', {
    staticClass: "desc"
  }, [_c('span', [_vm._v(_vm._s(_vm.arquivo.desc))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icone"
  }, [_c('i', {
    staticClass: "fa fa-file fa-2x"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29f30e11","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/BaseLinkDocumento.vue
// module id = 474
// module chunks = 0